export default __webpack_public_path__ + "static/media/img_18.df0a7107.png";